module.exports = __webpack_public_path__ + "media/images/icons-a299a68b.svg";